module.exports = __webpack_public_path__ + "static/media/zostan-w-domu.f805d551.svg";